import {z} from 'zod';
import {ELEMENT} from '../../elements/base/ElementTypes';
import {SequenceQuestionMode} from '../../elements/question/questionSequence';
import {answerValidator, questionBaseValidator} from './questionBase';

export const sequenceQuestionValidator = questionBaseValidator.extend({
    type: z.literal(ELEMENT.SEQUENCE_QUESTION),
    sequence: z.array(answerValidator).min(2, 'sequence;min;2'),
    sequenceMode: z.nativeEnum(SequenceQuestionMode).optional(),
});
